import React from 'react';

import { SafeHTML } from '@/components/SafeHTML';

interface ContentSectionProps {
  content: string | null | undefined;
}

/**
 * Displays HTML content safely sanitized
 */
export const ContentSection: React.FC<ContentSectionProps> = ({ content }) => {
  if (!content) return null;

  return (
    <div className="prose max-w-none">
      <SafeHTML html={content} />
    </div>
  );
};
